import React, { useEffect } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import { useDispatch, useSelector } from 'react-redux';
import {
  checkUnsavedChanges,
  getCampaignList,
  _getLiveStatus,
  _setUpdatedCampaignList,
  _cancelDistCampaign,
  resetDestErrors,
  setDeleteRequest,
} from '../../../../../actions/deActions/deDistributeActions';
import { _getCampaignStatus } from '../../../../../util/deUtils';
import ContextMenu from './ContextMenu';
import { setCampaignDataToForm } from '../../../../../actions/deActions/deDistributeActions';

const RequestQueue = () => {
  const dispatch = useDispatch();
  const distributeData = useSelector(
    state => state.deDistribute.distributeData
  );
  const updatedCampaign = useSelector(
    state => state.deDistribute.updatedCampaign
  );
  const distRequest = useSelector(state => state.deDistribute.distRequest);
  const isDeleteRequest = useSelector(state => state.deDistribute.isDeleteRequest);
  const accountId = useSelector(state => state.account.activeAccountId);
  const impersonated = useSelector(state => state.login.loginResponse.data.impersonated);
  const { data = [], isLoading = true } = distributeData;
  const [hoverIndex, setHoverIndex] = React.useState(null);
  useEffect(() => {
    dispatch(getCampaignList());
  }, []);

  useEffect(() => {
    if(!isDeleteRequest){
      setHoverIndex(null)
    }
  }, [isDeleteRequest])
  const getScrollbarWidth = () => {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);
    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);
    // Calculating difference between container's full width and the child width
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
  };

  setTimeout(() => {
    const hasScroll =
      $('.datahub-table--body').get(0).scrollHeight >
      $('.datahub-table--body').height();
    if (hasScroll) {
      const scrollWidth = getScrollbarWidth();
      $('.datahub-table').addClass('has-scroll');
      $('.datahub-table .datahub-table--head').attr(
        'style',
        `padding-right: ${scrollWidth}px`
      );
    } else {
      $('.datahub-table').removeClass('has-scroll');
      $('.datahub-table .datahub-table--head').removeAttr('style');
    }
  }, 100);


  const _updateStatus = async (res, row, campaignList) => {
    let newStatus = '0';
    let ut = '';
    if (res && res.length > 0) {
      newStatus = res[0].status;
      ut = res[0].ut;
    }
    const newData = cloneDeep(campaignList);
    const campaignData = newData.map(item => {
      const obj = item;
      if (item.id === row.id) {
        obj.status = newStatus;
        obj.ut = ut;
      }
      return obj;
    });
    return campaignData;
  };
  const _handleOpenClick = async row => {
    let updatedCampaignList = data;
    if (row.status !== '0') {
      const getStatus = await _getLiveStatus(accountId, row.id, impersonated);
      updatedCampaignList = await _updateStatus(getStatus, row, data);
      if (getStatus.status !== 500) {
        dispatch(_setUpdatedCampaignList(updatedCampaignList));
      }
    }
    const updatedCampaign = updatedCampaignList.find(({ id }) => id === row.id);
    const hasUnsavedChanges = dispatch(checkUnsavedChanges());
    if (hasUnsavedChanges) {
      dispatch(setCampaignDataToForm(updatedCampaign, true));
    } else {
      dispatch(setCampaignDataToForm(updatedCampaign));
    }
  };
  const _handleCancelClick = async row => {
    const res = await _cancelDistCampaign(accountId, row.id);
    const updatedCampaignList = await _updateStatus(res, row, data);
    const updatedCampaign = updatedCampaignList.find(({ id }) => id === row.id);
    if (res.status !== 500) {
      dispatch(_setUpdatedCampaignList(updatedCampaignList));
      dispatch(setCampaignDataToForm(updatedCampaign));
    }
  };
  const _handleAction = (row, action) => {
    dispatch(resetDestErrors());
    switch (action) {
      case 'open': {
        _handleOpenClick(row);
        break;
      }
      case 'cancel': {
        _handleCancelClick(row);
        break;
      }
      case 'delete': {
        dispatch(setDeleteRequest(true, row.id, row.campName));
        break;
      }
      default:
    }
  };
  const _renderCampaigns = () => {
    if (isLoading) {
      return <div className="distro__rq__card--nodata">loading...</div>;
    }
    if (data.length === 0) {
      return (
        <div className="distro__rq__card--nodata">
          Your distribution requests will display in this section{' '}
        </div>
      );
    }
    return data.map((camp, index) => {
      const { campName, id, status } = camp;
      let rowClass = 'distro__rq__row';
      const rowIndex = index + 1;
      if (hoverIndex && rowIndex === hoverIndex) {
        rowClass += ' row-hover';
      }
      if (distRequest && distRequest.requestId === id) {
        rowClass += ' row-selected';
      }
      if (updatedCampaign) {
        if (String(updatedCampaign.campaignId) === String(id)) {
          rowClass += ' row-updated';
        }
      }
      return (
        <div className={rowClass} key={id}>
          <div className="distro__rq__col--rq-name" title={campName}>
            <div className="distro__rq__col--text">
              <div className="LinesEllipsis">{campName}</div>
            </div>
          </div>
          <div className="distro__rq__col--rq-status">
            <div className="distro__rq__col--text">
              {_getCampaignStatus(status)}
            </div>
            <div className="distro__rq__col--contextmenu">
              <ContextMenu
                data-test="labelcontextmenu"
                row={camp}
                onClick={_handleAction}
                setHoverIndex={setHoverIndex}
                rowIndex={rowIndex}
                status={_getCampaignStatus(status)}
                impersonated={impersonated}
              />
            </div>
          </div>
        </div>
      );
    });
  };
  return (
    <div className="distro__rq">
      <div className="distro__rq__card datahub-table">
        <div className="distro__rq__card__header datahub-table--head">
          <div className="distro__rq__row">
            <div className="distro__rq__col--rq-name">
              <div className="distro__rq__card__header--title">
                Request Name
              </div>
            </div>
            <div className="distro__rq__col--rq-status">
              <div className="distro__rq__card__header--title">Status</div>
            </div>
          </div>
        </div>
        <div className="distro__rq__card--body datahub-table--body">{_renderCampaigns()}</div>
      </div>
    </div>
  );
};

export default RequestQueue;
